<template>
  <div class="description text-uppercase">
    <strong>
      {{ $resourceString["product.details.specifications.product.vrating"] }}:
    </strong>
    <ul class="list-unstyled">
      <li class="v-rating">
        {{ selectedColor.colorVariationLevel.code }} -
        {{ selectedColor.colorVariationLevel.description }}

        <span
          @mouseover="mouseover"
          @mouseleave="mouseleave"
          class="ml-3 color-variant-info"
        >
          ?
        </span>
        <div
          id="hovercard"
          class="rating-content-card"
          v-show="showCard"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          <div class="description text-uppercase">
            <strong>
              {{
                $resourceString[
                  "product.details.specifications.product.vrating.heading"
                ]
              }}:
            </strong>
            <ul class="list-unstyled">
              <li v-for="rating in vrating" :key="rating">
                <strong> {{ rating }} : </strong>
                {{
                  $resourceString[
                    "product.details.specifications.product.vrating." + rating
                  ]
                }}
              </li>
            </ul>
            <img
              class="w-100"
              v-show="!specification"
              :src="ratingImageUrl"
              alt="v-rating level"
            />
          </div>
        </div>
      </li>
    </ul>
    <img
      class="w-50"
      v-show="specification"
      :src="ratingImageUrl"
      alt="v-rating level"
    />
    <p class="rating-desctiption" v-if="specification">
      {{
        $resourceString[
          "product.details.specifications.product.vrating.description"
        ]
      }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["specification"],
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color"
    })
  },
  data() {
    return {
      showCard: false,
      vrating: ["v1", "v2", "v3", "v4"],
      ratingImageUrl:
        "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/asides/v-rating-icon.png"
    };
  },
  methods: {
    mouseover(event) {
      this.showCard = true;
    },
    mouseleave(event) {
      this.showCard = false;
    }
  }
};
</script>
